import { gql } from '@apollo/client';

const productAttributeVariationsQuery = gql`
    query getProductAttributeVariations(
        $id: ID
        $store: ID!
        $language: Language!
        $preorderSeasonId: Int
        $includePreorderSeasonId: Int
    ) {
        product(
            store: $store
            language: $language
            id: $id
            preorderSeasonId: $preorderSeasonId
            includePreorderSeasonId: $includePreorderSeasonId
        ) {
            id
            key
            name
            sizeSpecification
            siblingAttributes {
                name
                value
            }
        }
    }
`;

export default productAttributeVariationsQuery;
